module.exports = __webpack_public_path__ + "media/bootstrap-icons/exclamation-circle-5811aed9.svg";